import React from 'react';
import {IIconProps} from "../../../../ui/svg/interfaces";
const RightArrowIcon = (props: IIconProps) => {
  return (
    <svg className={props.classes} xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox="0 0 7 10" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M1.7624 0.588032C1.43779 0.263305 0.911368 0.263305 0.586758 0.588031C0.262563 0.912343 0.262277 1.43794 0.586118 1.76261L3.8153 5L0.586118 8.23739C0.262277 8.56206 0.262563 9.08766 0.586758 9.41197C0.911368 9.7367 1.43779 9.7367 1.7624 9.41197L6.17278 5L1.7624 0.588032Z" fill={props.color}/>
    </svg>
  )
};

export default RightArrowIcon;